var e="@hpstellar/core/color-selection";export{e as colorSelectionTestId};
